import { MaskLine, Reveal } from "@/components/Reveal";

export const H2 = ({ children }) => <h2 className="font-display text-xl md:text-2xl font-medium text-foreground mb-4">{children}</h2>;
export const H3 = ({ children }) => <h3 className="font-medium text-foreground mt-6 mb-2">{children}</h3>;

export default function Legal({ title, children, testId }) {
  return (
    <main className="pt-36 pb-24" data-testid={testId}>
      <div className="mx-auto max-w-3xl px-6 md:px-8">
        <h1 className="font-display text-4xl lg:text-6xl font-medium leading-tight mb-14">
          <MaskLine animateOnMount delay={0.15}>{title}</MaskLine>
        </h1>
        <Reveal delay={0.3} className="space-y-10 text-muted-foreground leading-relaxed">{children}</Reveal>
      </div>
    </main>
  );
}
